import {Component, Module} from 'app/decorators';
import _ from 'lodash';


import tpl from './mapping.component.html';


@Module({
    name: "app.directives.mapping.component",
})
@Component({
    selector: 'blnd-mapping-component',
    bindings: {
        ngModel: '=',
        mode: '@?',
    },
    template: tpl,
})
export default class C {
    constructor() {
        "ngInject";
        let self = this;

        self.mode = self.mode || 'view';
    }

    add () {
        this.ngModel.push({});
    }

    remove (item) {
        let index = this.ngModel.indexOf(item);
        this.ngModel.splice(index, 1);
    }

    onPress (event, isLast) {
        if (event.which === 9 && isLast) {
            this.add();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/admin/components/mapping.component.js